import { render } from "./LearningOutcomes.vue?vue&type=template&id=24823396"
import script from "./LearningOutcomes.vue?vue&type=script&lang=js"
export * from "./LearningOutcomes.vue?vue&type=script&lang=js"

import "./LearningOutcomes.vue?vue&type=style&index=0&id=24823396&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__